import { ReactElement } from 'react';

import { DocplannerHealthcareProviderConfiguration } from '@dreryk/egabinet-docplanner-frontend-api';

import {
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalWidth,
   Notification,
   NotificationSize,
   NotificationType,
   StyledFlex,
} from '@dreryk/react-components';

import { integrationTranslationKeys } from '../../translations';

import { DocplannerUpdateSynchronizationDaysCountConfirmButton } from './DocplannerUpdateSynchronizationDaysCountConfirmButton';
import { DocplannerUpdateSynchronizationDaysCountForm } from './DocplannerUpdateSynchronizationDaysCountForm';

type DocplannerUpdateSynchronizationDaysCountModalProps = {
   readonly currentSynchronizationDaysCount: number;
   readonly onClose: VoidFunction;
   readonly onSubmitSuccess: (currentDocplannerConfiguration: DocplannerHealthcareProviderConfiguration) => void;
};

export const DocplannerUpdateSynchronizationDaysCountModal = (
   props: DocplannerUpdateSynchronizationDaysCountModalProps
): ReactElement => {
   return (
      <Modal
         testId={'updateClientSecretForm'}
         title={integrationTranslationKeys.updateSynchronizationDaysCount}
         width={ModalWidth.NORMAL}
      >
         <StyledFlex direction={'column'} gap={'24px'}>
            <Notification
               testId={'synchronizationDaysInfo'}
               type={NotificationType.INFO}
               label={integrationTranslationKeys.synchronizationDaysCountDescription}
               size={NotificationSize.SMALLER}
            />
            <DocplannerUpdateSynchronizationDaysCountForm
               currentSynchronizationDaysCount={props.currentSynchronizationDaysCount}
            >
               {({ handleSubmit, formState }) => (
                  <>
                     <DocplannerUpdateSynchronizationDaysCountConfirmButton
                        onSuccess={props.onSubmitSuccess}
                        handleSubmit={handleSubmit}
                     />
                     <ModalCancelButton shouldConfirmExit={formState.isDirty} onClick={props.onClose} />
                     <ModalCloseButton shouldConfirmExit={formState.isDirty} onClick={props.onClose} />
                  </>
               )}
            </DocplannerUpdateSynchronizationDaysCountForm>
         </StyledFlex>
      </Modal>
   );
};
